module.exports = __webpack_public_path__ + "img/icon_zanting.9b81b1de.svg";